import { ComboBox } from "@xola/ui-kit";
import React from "react";
import { RemoteGatewayType } from "types";
import { useSeller } from "../../../hooks/useAccount";
import { ContentLayout } from "../../Layout/ContentLayout";

interface PaymentGatewaySelectorProps {
    selectedGateway: RemoteGatewayType | null;
    onChange: (option: GatewayOption) => void;
}

export const PaymentGatewaySelector = ({ selectedGateway, onChange }: PaymentGatewaySelectorProps) => {
    const seller = useSeller();
    let gateway = seller.defaultGateway?.id ? seller.defaultGateway.type : null;

    if (gateway === null) {
        if (seller.allowedGateways.length === 0) {
            return <>No Payment Gateway configured</>;
        }

        [gateway] = seller.allowedGateways;
    }

    return (
        <ContentLayout.Section title="Payment Gateway">
            <ComboBox
                placeholder="Select Payment Gateway"
                value={options.find((option) => option.value === selectedGateway)}
                options={getAllowedGatewayOptions(seller.allowedGateways)}
                getOptionValue={(option: GatewayOption) => option.value}
                classNames={{ option: () => "no-translate", singleValue: () => "no-translate" }}
                onChange={onChange}
            />
        </ContentLayout.Section>
    );
};

export interface GatewayOption {
    label: string;
    value: RemoteGatewayType;
}

const options: GatewayOption[] = [
    {
        label: "Xola (Stripe)",
        value: RemoteGatewayType.STRIPE_XOLA,
    },
    {
        label: "Stripe OAuth",
        value: RemoteGatewayType.STRIPE_OAUTH,
    },
    {
        label: "Authorize.Net (CIM)",
        value: RemoteGatewayType.AUTHORIZE_NET_CIM,
    },
];

const getAllowedGatewayOptions = (allowedGateways?: RemoteGatewayType[]): GatewayOption[] => {
    if (!allowedGateways) {
        return [];
    }

    return options.filter((option) => allowedGateways.includes(option.value));
};
